module.exports = __webpack_public_path__ + "static/img/sy.64f0d2d7.svg";